import updateSearchFields from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/UpdateSearchFields";
import translate from "@insite/client-framework/Translate";
import Checkbox, { CheckboxPresentationProps } from "@insite/mobius/Checkbox";
import { CustomState } from "@preferredMedical/Store/CustomState";
import setIsBackordered from "@preferredMedical/Store/Pages/OrderHistory/Handlers/SetIsBackordered";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomState) => ({
    isBackordered: state.custom.orderHistory.isBackordered,
    getOrdersParameter: state.pages.orderHistory.getOrdersParameter,
});

const mapDispatchToProps = {
    updateSearchFields,
    setIsBackordered,
};

export interface OrderHistoryIsBackorderedStyles {
    isBackordered?: CheckboxPresentationProps;
}

export const orderHistoryIsBackorderedStyles: OrderHistoryIsBackorderedStyles = {};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const OrderHistoryIsBackordered = ({
    isBackordered,
    updateSearchFields,
    setIsBackordered,
    getOrdersParameter,
}: Props) => {
    useEffect(() => {
        if (getOrdersParameter.vmiOrdersOnly === false || `${getOrdersParameter.vmiOrdersOnly}` === "false") {
            setIsBackordered({ isBackordered: false });
        } else if (getOrdersParameter.vmiOrdersOnly === undefined || getOrdersParameter.vmiOrdersOnly === null) {
            setIsBackordered({ isBackordered: false });
        } else {
            setIsBackordered({ isBackordered: true });
        }
    }, [getOrdersParameter]);

    const backordersChangeHandler = (_event: any, value: boolean) => {
        setIsBackordered({ isBackordered: value });
        updateSearchFields({ vmiOrdersOnly: value });
    };

    return (
        <Checkbox
            {...orderHistoryIsBackorderedStyles.isBackordered}
            onChange={backordersChangeHandler}
            checked={isBackordered}
            variant="toggle"
            labelPosition="right"
        >
            {translate("Show Open Backorders")}
        </Checkbox>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderHistoryIsBackordered);
